import { render, staticRenderFns } from "./BlogButtonMod.vue?vue&type=template&id=7a3b8a9c&scoped=true"
import script from "./BlogButtonMod.vue?vue&type=script&lang=js"
export * from "./BlogButtonMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3b8a9c",
  null
  
)

export default component.exports